import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';
import { Notification } from 'element-ui';
import { API_HOST } from  './config';

export  const ajax =(url,options)=>{
  let axiosOptions = {};
  options.ISBODY = options.ISBODY || false;
  axiosOptions.withCredentials = false;
  axiosOptions.baseURL = options.baseURL || process.env.NODE_ENV === 'production' ? API_HOST : '/fn'
  axiosOptions.headers = {
    'content-type': !options.ISBODY? 'application/x-www-form-urlencoded':'application/json; charset=UTF-8',
    ...options.headers
  };
  axiosOptions.method = options.method || 'get';
  axiosOptions.timeout = options.method || 10 * 1000;
  if (options.data && _.includes(['get', 'delete'], options.method)){
    axiosOptions.params = options.data;
  }else if(options.data && _.includes(['post'], options.method)) {
    // console.log(options.ISBODY)
    if(options.ISBODY) {
      axiosOptions.data = options.data
    }else {
      axiosOptions.data = qs.stringify(options.data)
    }
  }else {
    axiosOptions.data = options.data
  };
  return new Promise((resolve, reject) => {
    axios(url, axiosOptions).then(res => {
      const status = res.status.toString()
      if (status.startsWith('2')) {
        const code = res.data.code;
        if (code == 0) {
          resolve(res.data)
        } else if (code == 500) { //-1 未登录 500错误码 1015账户未注册
          reject({
            handled: false,
            message: _.get(res.data, 'message')
          })
        } else if (code == -1) { //-1 未登录 500错误码 1015账户未注册
          _defaultErrorHandler('x01')
        } else {
          _defaultErrorHandler(code)
        }
      }else {
        if(!navigator.onLine) {
          _defaultErrorHandler(2)
        }else {
          _defaultErrorHandler(1)
        }
      }
    }).catch((err) => {
      reject(err)
      if(!navigator.onLine) {
        _defaultErrorHandler(2)
      }else {
        _defaultErrorHandler(1)
      }
    })
  })
};

/*错误提示定义*/
const tips = {//-1 未登录 500错误码 1015账户未注册
  1: { title: '服务繁忙，请稍后重试' },
  2: { title: '断网了，请检查网络'},
  x01: { title: '您还未登录', name: 'login'},
  1015: { title: '您的账号还未注册', name: 'register'},
  1003: { title: '错误', name: 'register'},
  1010: { title: '出错了!' },
  1001: { title: '出错了!' },
  404: { title: '出错了!' }
}


const _defaultErrorHandler = (errCode) => {
  console.log("错误码");
  console.log(errCode);
  if (!errCode)
    errCode = 1;
    Notification({message:tips[errCode].title});
  // Toast(tips[errCode].title)
    // router.push({
    //   name: tips[errCode].name
    // })
};

export const GET = (url='', options={}) => ajax(url, {
  ...options,
  method: 'get'
})
export const PUT = (url='', options={}) => ajax(url, {
  ...options,
  method: 'put'
})
export const POST = (url='', options={}) => ajax(url, {
  ...options,
  method: 'post'
})
export const DELETE = (url='', options={}) => ajax(url, {
  ...options,
  method: 'delete'
});

export default ajax;
